module.exports = "<b-form params=\"form:result.form,attrs:result.attrs\"></b-form>";


//////////////////
// WEBPACK FOOTER
// ./src/template/QForm.html
// module id = 90
// module chunks = 0